module.exports = __webpack_public_path__ + "img/users-active.5abe95b7.svg";